var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1708599129206,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4249,
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.496 125.333333a32 32 0 0 0-44.672 45.717334l2.346667 2.282666L736.426667 512 352.170667 850.666667a32 32 0 0 0-4.885334 42.602666l2.048 2.56a32 32 0 0 0 42.602667 4.885334l2.56-2.048 411.477333-362.666667a32 32 0 0 0 2.389334-45.653333l-2.389334-2.346667-411.477333-362.666667z",
    fill: "#515a67",
    "p-id": 4250
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGo);
export default __webpack_public_path__ + "static/media/go.4d413388bde2b597702927b681901fb6.svg";
export { ForwardRef as ReactComponent };